import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import AccordionPanel from '@/components/UI/AccordionPanel/AccordionPanel';
import InfoMsg from '@/components/UI/InfoMsg/InfoMsg';
import infoMsgStyles from '@/components/UI/InfoMsg/InfoMsg.module.scss';
import SummaryVehiclesCleanDirt from '@/containers/CampaignDetail/AffectedVehicles/Volume/VolumeDetails/Summary/SummaryVehiclesCleanDirt';
import AttachmentFile from '@/containers/CampaignDetail/Attachments/AttachmentFile/AttachmentFile';
import { HELP_AREA } from '@/helpers/constants';
import useDownloadFile from '@/hooks/useDownloadFile';
import { getCampaignInfo, getCampaignVehicles } from '@/redux/Campaign/campaign.reducer';
import { getHeaderLanguage } from '@/redux/Header/header.reducer';
import { setAreaHelp } from '@/redux/Help/help.action';
import { AffectedVehicles, Language } from '@/types';
import LimitationTable from './LimitationTable';
import styles from './LimitationVolume.module.scss';

interface LimitationVolumeProps {
  affectedVehicles: AffectedVehicles;
  setHelpArea: (area: string) => void;
  headerLanguage: Language;
}

const LimitationVolume: React.FC<LimitationVolumeProps> = (props) => {
  const { affectedVehicles, setHelpArea, headerLanguage } = props;
  const { t } = useTranslation();
  const { downloadFile } = useDownloadFile();
  const volume = affectedVehicles?.volumes?.[0] || {};

  return (
    <AccordionPanel
      title={t('affectedVehicles.volume')}
      handleClick={() => setHelpArea(HELP_AREA.VOLUME)}
    >
      {volume.fileOptionSelected && (
        <section className={styles.Wrapper}>
          {volume.vehicleRestrictionFiles.map((file) => (
            <AttachmentFile
              key={file.fullName}
              attachment={file}
              onDownload={downloadFile}
              isAffectedVehicles
            />
          ))}
        </section>
      )}
      {!volume.fileOptionSelected && volume.limitationVolumeManualEntry && (
        <>
          <LimitationTable volume={volume.limitationVolumeManualEntry} headerLanguage={headerLanguage} />
          <SummaryVehiclesCleanDirt plantWkz={volume.plant} />
        </>
      )}
      {!volume.fileOptionSelected && !volume.limitationVolumeManualEntry && (<InfoMsg customClass={infoMsgStyles.LimitVolumeNoDataInfoMsg} msg={t('affectedVehicles.limitVolumeNoData')} />)}
    </AccordionPanel>
  );
};

const mapStateToProps = (state) => ({
  headerLanguage: getHeaderLanguage(state) || getCampaignInfo(state)?.defaultLanguage,
  affectedVehicles: getCampaignVehicles(state),
});

const actionCreators = {
  setHelpArea: setAreaHelp,
};

export default connect(mapStateToProps, actionCreators)(LimitationVolume);
